import React, {useContext} from "react";
import {useAuth} from "../context/auth";
import {Redirect } from "react-router-dom";
import {JWT} from "../constants/local-storage";
import {RESOLUTION_STATE_VALUES} from "../constants/local-storage";
import {CHANGE_LOGGED_IN} from "../constants/action-types";
import {store} from '../context/store.js';
import omniScanLogo from "../images/omniscanlogo.png";
import { useHistory } from "react-router-dom";

export default function LogOut(){
	
	const {setAuthTokens} = useAuth();
	const history = useHistory();
	const globalState = useContext(store);
	const {dispatch} = globalState;
	
	
	const thisContainer = {
			display:'flex',
			width:'100vw',
			height:'100vh',
			justifyContent:'space-around',
			flexDirection:'row',
			flexDirection:"column",
			alignItems:"center"
	};
	
	
	const instructionsPanel = {
		display:"flex",
		alignItems:"center",
		padding:"20px",
		backgroundColor:"white",
		borderRadius:"3px",
		width:"400px",
		paddingBottom:"30px",
		marginTop:"-100px",
		zIndex:"300",
		boxShadow:"0 4px 8px rgba(0, 0, 0, 0.1)",
	}
	
	const instructions = {
		display:"flex",
		fontSize:"16px",
		color:"black",
		alignItems:"center",
		paddingLeft:"60px",
		paddingTop:"15px"
	};
	
	const goLogout = () => {
  setAuthTokens(null);
  localStorage.setItem(JWT, "null");
  localStorage.setItem(RESOLUTION_STATE_VALUES, JSON.stringify({}));
  dispatch({ type: CHANGE_LOGGED_IN, value: "" });
  history.push("/");
};
	
	
	
	const blueButton = {
		display:"flex",
		backgroundColor:"black",
		paddingLeft:"20px",
		paddingRight:"20px",
		borderRadius:"4px",
		fontSize:"12px",
		color:"white",
		alignItems:"center",
		justifyContent:"space-around",
		cursor:"pointer",
		height:"40px",
		marginLeft:"20px",
		marginTop:"15px"
	};
	
	const omniScanLogoStyle = {
		display:"flex",
		width:"400px",
		height:"100px",
		position:"fixed",
		left:"20px",
		top:"20px"
	};
	
	return (
		<div style={thisContainer}>
			<img src={omniScanLogo} style={omniScanLogoStyle}  alt="OmniScan company logo" />
			<div style={instructionsPanel}>
				<div style={instructions}>
					Log back into the system?
				</div>
				 <div style={blueButton} onClick={goLogout}>
				 GO
				 </div>
			</div>
		</div>
	);
}